import React, { useState } from 'react';

import { usePdpContext } from '../../pdp-provider';
import CheckboxField from '@starbucks-web/pattern-library/lib/components/checkbox-field';

const YesNoCheckbox = ({
  categoryKeyPath,
  productOption,
  topLevelCategoryName,
  topLevelCategoryNumber,
}) => {
  const {
    isCustomizing,
    productOptionDefaults,
    selectedOptions,
    updateProductOption,
  } = usePdpContext();

  const optionProductNumber = productOption?.productNumber;
  const optionFormName = productOption?.form?.name;

  const getStartingValue = () => {
    const preselectedOption = selectedOptions?.find(
      (option) => option.optionProductNumber === optionProductNumber
    );
    const defaultValue =
      productOptionDefaults?.optionProductNumber?.defaultValue;

    if (preselectedOption) {
      return preselectedOption.value;
    } else if (defaultValue) {
      return defaultValue;
    }
    return false;
  };

  const [value, setValue] = useState(() => getStartingValue());

  const onCheckboxClick = () => {
    updateProductOption({
      categoryKeypath: categoryKeyPath,
      formCode: 'yes-no',
      optionProductNumber,
      size: productOption?.form?.sizes?.[0],
      topLevelCategoryNumber,
      value: !value,
    });
    setValue(!value);
  };
  // replace any spaces in name for use as id attribute
  const idValue = optionFormName.replace(/\s+/g, '');

  return (
    <CheckboxField
      checkboxId={`${idValue}-checkbox`}
      checked={value}
      label={optionFormName}
      onUpdate={onCheckboxClick}
      secondaryLabel={
        // we want the active 'floatLabel' to only appear on the "What's included" pane, as it is
        // noisy and not that helpful on the "Customizations" pane
        isCustomizing ? undefined : topLevelCategoryName
      }
      useInactiveStyle={!value}
    />
  );
};

export default YesNoCheckbox;
